import { render, staticRenderFns } from "./TaxList.vue?vue&type=template&id=6946a524&scoped=true"
import script from "./TaxList.vue?vue&type=script&lang=js"
export * from "./TaxList.vue?vue&type=script&lang=js"
import style0 from "./TaxList.vue?vue&type=style&index=0&id=6946a524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6946a524",
  null
  
)

export default component.exports